import { render } from "./TableStatusCount.vue?vue&type=template&id=37b191c8"
import script from "./TableStatusCount.vue?vue&type=script&lang=js"
export * from "./TableStatusCount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__